export default {
  props: {
    id: {
      type: Number,
      required: true
    },

    viewed: {
      type: Boolean,
      required: true
    },

    payload: {
      type: [Object, Array],
      required: true
    },

    hours: {
      type: String,
      required: true
    },

    createdAt: {
      type: String,
      required: true
    }
  },

  computed: {
    isAdmin() {
      return this.$store.state.user.profile.isAdmin;
    }
  },

  methods: {
    getPackageName(id) {
      let result = null;
      this.$store.state.payments.packages.forEach(plan => {
        if (plan.tariffs.find(tariff => tariff.id === id)) {
          result = plan;
        }
      });
      return result;
    },

    emitClick() {
      this.$emit('clickLink');
    }
  }
};
